import toast from "react-hot-toast";
import { Checkbox, Label, Modal } from "flowbite-react";
import { addInfluencerToList, removeInfluencerFromList } from "../../api/instagram";
import { useLists } from "../../contexts/ListsContext";

const ListModal = ({ openModal, setOpenModal, loadingInfluencerData, lookalike, refreshLists, lookalikeLists, network }) => {
  const { lists } = useLists();

  if (!lookalike) return null;

  const toggleInfluencerInTheList = async (e, list) => {
    try {
      const action = e.target.checked ? addInfluencerToList : removeInfluencerFromList;
      const data = e.target.checked 
        ? { listId: list._id, lookalike, platform: network }
        : { listId: list._id, userId: lookalike.userId };

      await action(data);
      const actionMessage = e.target.checked
        ? `@${lookalike.profile.username || lookalike.profile.handle} has been added to ${list.name}`
        : `@${lookalike.profile.username || lookalike.profile.handle} has been removed from ${list.name}`;

      toast.success(actionMessage);
      await refreshLists();
    } catch (error) {
      console.error(error);
      toast.error(error?.response?.data?.message || error.message || 'An error occurred');
    }
  }

  return (
    <Modal show={openModal} size="md" onClose={() => setOpenModal(false)} popup>
      <Modal.Header />
      <Modal.Body>
        <div className="space-y-6">
          <h3 className="text-xl font-medium text-gray-900 dark:text-white">
            Manage @{lookalike.profile.username} lists
          </h3>

          {loadingInfluencerData ? (
            <div className="text-gray-500">Loading influencer data...</div>
          ) : (
            <div className="flex flex-col gap-4">
              {lists.length ? (
                lists.map((list) => (
                  <div className="flex items-center gap-2" key={list._id}>
                    <Checkbox
                      onChange={(e) => toggleInfluencerInTheList(e, list)}
                      id={list._id}
                      defaultChecked={lookalikeLists.includes(list._id)}
                    />
                    <Label htmlFor={list._id}>
                      {list.name} ({list.count})
                    </Label>
                  </div>
                ))
              ) : (
                <div className="text-gray-500">There are no lists created yet</div>
              )}
            </div>
          )}
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default ListModal;
